import { ReactElement, useEffect, useState } from 'react';
import { Grid } from '@mui/material';

import { useLocation } from 'react-router-dom';

import { useProductArea, useRoutes } from '@localstack/services';
import { ProductArea } from '@localstack/constants';

import { ContainedCustomerLayout } from '~/layouts/Customer/ContainedCustomerLayout';
import { AppRoute } from '~/config';

import { useAuthProvider } from '~/hooks/useAuthProvider';

import { InstanceBookmarks } from './InstanceBookmarks';
import { InstanceEphemeral } from './InstanceEphemeral';

enum ToggleState {
  BOOKMARK = 'bookmark',
  EPHEMERAL = 'ephemeral',
}

export const Instances = (): ReactElement => {
  const location = useLocation();
  const { goto } = useRoutes();

  const defaultToggle =
    location.pathname === AppRoute.INSTANCES_EPHEMERAL ? ToggleState.EPHEMERAL : ToggleState.BOOKMARK;

  const [toggleState, setToggleState] = useState<ToggleState>(defaultToggle);

  const hasAccessToProductArea = useProductArea({ useAuthProvider });
  const showInstanceTabs = hasAccessToProductArea(ProductArea.EPHEMERAL_INSTANCES);

  useEffect(() => {
    goto(toggleState === ToggleState.BOOKMARK ? AppRoute.INSTANCES : AppRoute.INSTANCES_EPHEMERAL);
  }, [toggleState]);

  useEffect(() => {
    setToggleState(location.pathname === AppRoute.INSTANCES_EPHEMERAL ? ToggleState.EPHEMERAL : ToggleState.BOOKMARK);
  }, [location]);

  return (
    <ContainedCustomerLayout
      documentTitle="LocalStack Instance Management"
      breadcrumbs={[{ label: 'Instances' }, { label: 'New Instance' }]}
      links={[
        { label: 'Bookmarks', href: AppRoute.INSTANCES, display: showInstanceTabs },
        { label: 'Ephemeral', href: AppRoute.INSTANCES_EPHEMERAL, display: showInstanceTabs },
      ]}
    >
      <Grid container spacing={2}>
        {toggleState === ToggleState.BOOKMARK ? <InstanceBookmarks /> : <InstanceEphemeral />}
      </Grid>
    </ContainedCustomerLayout>
  );
};
